import { appwriteConfig } from '../../../../config/environment';
import { runCommand } from '../../../../services/appwrite/command-gateway';

export interface MediaGateway {
  run<T>(action: string, data?: Record<string, unknown>): Promise<T>;
}

/**
 * Única frontera del cliente con la Function de media.
 *
 * Las pantallas describen la acción que necesitan, pero no conocen el ID de
 * la Function ni cómo se transporta. Si media cambia de nombre o de backend,
 * solo se modifica este gateway.
 */
export const mediaGateway: MediaGateway = {
  run<T>(action: string, data: Record<string, unknown> = {}) {
    return runCommand<T>(action, data, appwriteConfig.mediaFunctionId);
  },
};

